export const POPUP_NSPACE = 'popup';

export const SET_OPEN = 'SET_OPEN';
export const SET_CLOSE = 'SET_CLOSE';

export default {
  namespaced: true,
  state: {
    stack: []
  },
  getters: {
    component(state) {
      return {
        component: state.component,
        props: state.props,
        listeners: state.listeners
      };
    }
  },
  mutations: {
    [SET_OPEN](state, { component, props, listeners }) {
      state.stack.push({ component, props, listeners });
    },
    [SET_CLOSE](state) {
      if (state.stack.length > 0) {
        state.stack.pop();
      }
    }
  },
  actions: {
    openPopup({ commit }, { component, props = {}, listeners = {} }) {
      commit(SET_OPEN, { component, props, listeners });
    },
    closePopup({ commit }) {
      commit(SET_CLOSE);
    }
  }
};
